/* global $crisp */
import each from 'lodash/each'
import map from 'lodash/map'

export function crispTrack(eventType, data) {
  if (!$crisp) return
  if (eventType === 'view') {
  } else {
    $crisp.push(['set', 'session:event', [[[eventType.action, eventType.userId, 'blue']]]])
  }
}

export function setCrispData(me) {
  if (!window.$crisp) return
  const userData = {
    email: me.email,
    phone: me.profile.phone,
    nickname: me.profile.fullName
  }
  let sessionData = {
    fullName: me.profile.fullName,
    user_id: me._id,
    verified: me.verified,
    created_at: me.createdAt * 0.001
  }

  each(userData, (data, key) => {
    if (!data || !key) return
    $crisp.push(['set', 'user:' + key, [data]])
  })

  $crisp.push([
    'set',
    'session:data',
    [
      map(sessionData, (data, key) => {
        return [key, data]
      }).filter(array => {
        if (!array[0] || !array[1]) return false
        return true
      })
    ]
  ])
}

export function crispHide() {
  if (!$crisp) return
  return $crisp.push(['do', 'chat:hide'])
}



// WEBPACK FOOTER //
// ./src/App/helpers/track/crisp.js